export const PARTNER_NONE = '__none__';

export const DEFAULT_REPORT_LANG = 'pt' as const;

export const REPORT_LANG_OPTIONS = [
  { value: 'pt', label: 'Português' },
  { value: 'es', label: 'Espanhol' },
] as const;
